import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ChemicalTypeService } from '../proxy/general/controllers/chemical-type.service';
import { ChemicalService } from '../proxy/general/controllers/chemical.service';
import { PlantationTypeService } from '@planning/proxy/planning/controllers/plantation-type.service';
import { PlantTypeService } from '@general/proxy/general/controllers';

FieldBuilder.setNamespace('General');

export const RECOMMENDEDQUANTITYPERRESOURCE_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('plantTypeId', 'Entity.PlantType', PlantTypeService)
    .required()
    .displayFromNested('plantType.name')
    .sortBy('plantType.name')
    .build(),
  FieldBuilder
    .number('quantity', 'Entity.RecommendedQuantityPerResource.Quantity')
    .required()
    .decimal(3,8)
    .build(),
  FieldBuilder
    .checkbox('isManual', 'Entity.RecommendedQuantityPerResource.IsManual')
    .build(),
   FieldBuilder 
    .foreignKey('plantationTypeId', 'Entity.RecommendedQuantityPerResource.PlantationType', PlantationTypeService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const RECOMMENDEDQUANTITYPERRESOURCE_CONFIG = {
  entityName: 'RecommendedQuantityPerResource',
  localizationKey: 'General::Entity.RecommendedQuantityPerResource',
  fields: RECOMMENDEDQUANTITYPERRESOURCE_FIELDS,
  permission: 'Silviculture.RecommendedQuantityPerResources',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Silviculture + MENU_NAME_SUFFIX,
  menuSubcategory: undefined,
};
